/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectionValueValidationModel
 */
export interface SelectionValueValidationModel {
    /**
     * 
     * @type {number}
     * @memberof SelectionValueValidationModel
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof SelectionValueValidationModel
     */
    max?: number;
}

/**
 * Check if a given object implements the SelectionValueValidationModel interface.
 */
export function instanceOfSelectionValueValidationModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SelectionValueValidationModelFromJSON(json: any): SelectionValueValidationModel {
    return SelectionValueValidationModelFromJSONTyped(json, false);
}

export function SelectionValueValidationModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectionValueValidationModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
    };
}

export function SelectionValueValidationModelToJSON(value?: SelectionValueValidationModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'min': value.min,
        'max': value.max,
    };
}

